import { configureStore } from "@reduxjs/toolkit";

//#region SLICES
import timelineSlice from "./Slices/timelineSlice";
import alertSlice from "./Slices/alertSlice";
import candidateSlice from "./Slices/candidateSlice";
import sessionSlice from "./Slices/sessionSlice";
import orgAdminSlice from "./Slices/orgAdminSlice";
import adminSlice from "./Slices/adminSlice";
import supervisorSlice from "./Slices/supervisorSlice";
//#endregion

//#region STORE
const store = configureStore({
  reducer: {
    timeline: timelineSlice,
    alertSlice: alertSlice,
    candidateSlice: candidateSlice,
    sessionSlice: sessionSlice,
    orgAdminSlice: orgAdminSlice,
    adminSlice: adminSlice,
    supervisorSlice: supervisorSlice,
  },
});
//#endregion

export default store;
